<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :customUpdateAction="customUpdateAction"
    titleKey="last_version.name"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/checklist_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    customUpdateAction: (modelData) => {
      if (modelData.range_type === "exclusive") {
        modelData.factories = []
      }
      if(modelData.range_type === "general") {
        modelData.exclusive_factories = null
      }
    },
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: ["last_version"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "frequency",
                "areas",
                "industry_categories",
                "system_classes",
                "system_subclasses",
                "range_type",
                "factories",
                "exclusive_factories",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              remark: "隱藏的內容將不會顯示於使用者前台介面",
              fields: ["status"],
            },
          ],
        },
      ],
    },
  }),
};
</script>